<template>
  <div class="flex pt-11 lg:pt-26px space-x-28">
    <router-link class="link"
                 :class="{current: isSettings}"
                 :to="{name:'settings-space'}">{{ $t('settings') }}</router-link>
    <router-link class="link"
                 :class="{current: isProfile}"
                 :to="{name:'profile-settings'}">{{ $t('profile') }}</router-link>
    <router-link class="link"
                 :class="{current: isHelp}"
                 :to="{name:'ticket-system'}">{{ $t('help') }}</router-link>
  </div>
</template>

<script>
import {HELP_ROUTES, PROFILE_ROUTES, SETTINGS_ROUTES} from './accountRoutes';

export default {
  name: 'AccountNavigation',
  computed: {
    isSettings() {
      return SETTINGS_ROUTES.includes(this.$route.name);
    },
    isProfile() {
      return PROFILE_ROUTES.includes(this.$route.name);
    },
    isHelp() {
      return HELP_ROUTES.includes(this.$route.name);
    },
  },
  i18n: {
    messages: {
      en: {
        settings: 'Settings',
        profile: 'Profile',
        help: 'Help',
      },
      ru: {
        settings: 'Настройки',
        profile: 'Профиль',
        help: 'Помощь',
      },
    },
  },
};
</script>
